<div class="excel_report {{class}}" [hidden]="util.isMobile()" *ngIf="isPaid || isSuperAdmin">
  <button 
    class="tw-text-[#0F93CC] tw-flex tw-justify-center tw-items-center tw-px-5 tw-py-3 tw-gap-2 focus:tw-outline-0 hover:tw-bg-blue-50 tw-transition-colors tw-h-10 tw-relative tw-min-w-[40px] tw-rounded-full" 
    [class.tw-border]="showBorder"
    [class.tw-border-[#0F93CC]]="showBorder"
    [matMenuTriggerFor]="menu" 
    [disabled]="type==='empty' || disableReport" 
    [mhTooltip]="'header.tooltips.download_report' | translate"
    width="tw-w-fit" 
    position="above"
  >
    <div [class.show]="waiting" class="spinner_wait">
      <mh-spinner-classic></mh-spinner-classic>
    </div>
    <i class="far fa-arrow-to-bottom tw-text-[#0F93CC]" [hidden]="type==='empty'" [class.waiting]="waiting"></i>
  </button>

  <mat-menu #menu="matMenu">
    <button mat-menu-item  (click)="getReport()" *ngIf="!onlyEmail">
      <i class="fal fa-download"></i> {{'reports.downloads.excel.download_report' | translate}}
    </button>
    <button mat-menu-item (click)="getReport(true)" *ngIf="activeEmail">
      <i class="fal fa-envelope"></i> {{'reports.downloads.excel.send_report' | translate}}
    </button>
    <button mat-menu-item (click)="getReport(true, true)" *ngIf="type === 'chainOnlineSummary'">
      <i class="fal fa-envelope"></i> {{'reports.downloads.excel.review_online_report' | translate}}
    </button>
    <button mat-menu-item (click)="getReport(true, false, false, true)" *ngIf="type === 'chainFollowupSummary' || type === 'chainOnsiteFollowupSummary'">
      <i class="fal fa-envelope"></i> {{'reports.downloads.excel.guests_survey_report' | translate}}
    </button>
  </mat-menu>

</div>
